import { useNavigate } from "react-router-dom";
import AuthForm from "../components/AuthForm";

const Login = () => {
  const navigate = useNavigate();

  return (
    <div>
      <AuthForm onAuthSuccess={() => navigate("/game")} />
    </div>
  );
};

export default Login;
